import { lazy } from 'react'

export const PaymentVariant5 = lazy(() => import('./PaymentVariant5'))
